export default __webpack_public_path__ + "static/media/landscape16.97fee12e.jpg";